import React from 'react';
import { toneStyle } from './licenseStatus';

/**
 * <LicenseBadge> - kleines Status-Lozenge in der Farbe des uebergebenen tone.
 */
export default function LicenseBadge({ tone = 'muted', children, title }) {
  const s = toneStyle(tone);
  return (
    <span
      title={title}
      style={{
        display: 'inline-block', padding: '2px 9px', borderRadius: 20,
        fontSize: 11, fontWeight: 700, lineHeight: 1.6,
        color: s.color, background: s.bg, border: `1px solid ${s.border}`,
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </span>
  );
}
